import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, Button, Link } from '@ontruck/orc';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { selectors, actions } from 'state/auth';
import { history } from 'state/store';
import routes from 'utils/routes';

const SignUpForm = ({ className, userDataHash }) => {
  const { t } = useTranslation('authSignUpForm');
  const dispatch = useDispatch();
  const [formValues, setFormValues] = useState({
    name: '',
    surname: '',
    password: '',
  });
  const error = useSelector((state) => selectors.getAuthError(state));

  const handleUpdateValue = useCallback(
    (e, { value, name }) => {
      setFormValues({
        ...formValues,
        [name]: value,
      });
    },
    [formValues]
  );

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      try {
        dispatch(actions.signUp({ ...formValues, userDataHash }));
      } catch (err) {
        console.error('Action signup error', err);
      }
    },
    [formValues, dispatch, userDataHash]
  );

  if (error) {
    return (
      <div className={className} data-testid="signup-form">
        <h2 className="title">{t('error.title')}</h2>
        <p className="error-msg">{t(error)}</p>
        {error === 'authSignUpForm:error.already_register' && (
          <Link
            className="login-link"
            text={t('redirect_login')}
            onClick={() => {
              dispatch(actions.setError(''));
              history.push(routes.login);
            }}
          ></Link>
        )}
        {error !== 'authSignUpForm:error.already_register' && (
          <Link
            className="login-link"
            text={t('try_again')}
            onClick={() => {
              dispatch(actions.setError(''));
              history.push(`${routes.signup}/${userDataHash}`);
            }}
          ></Link>
        )}
      </div>
    );
  }

  return (
    <div className={className} data-testid="signup-form">
      <h2 className="title">{t('title')}</h2>
      <form className={`form ${error && 'form-error'}`} onSubmit={handleSubmit}>
        <Field
          id="name"
          type="text"
          name="name"
          onChange={handleUpdateValue}
          label={t('name_label')}
          fullWidth
          value={formValues.name}
          dataE2E="signup_name"
        />
        <Field
          id="surname"
          type="text"
          name="surname"
          onChange={handleUpdateValue}
          label={t('surname_label')}
          fullWidth
          value={formValues.surname}
          dataE2E="signup_surname"
        />
        <div className="tax-data inspectlet-sensitive">
          <Field
            id="password"
            name="password"
            onChange={handleUpdateValue}
            label={t('password_label')}
            type="password"
            fullWidth
            value={formValues.password}
            dataE2E="signup_password"
          />
        </div>

        <Button
          id="submit"
          type="submit"
          size="L"
          text={t('button_label')}
          dataE2E="login_submit"
          data-testid="signup-form-submit"
          disabled={
            !formValues.name || !formValues.surname || !formValues.password
          }
        />
      </form>
    </div>
  );
};

SignUpForm.propTypes = {
  className: PropTypes.string.isRequired,
  t: PropTypes.func,
};

SignUpForm.defaultProps = {
  t: (t) => t,
};

export default SignUpForm;
